import { validationMessages } from './validationMessages.schema';

export default {
  type: 'object',
  properties: {
    value: {
      title: 'Wartość',
      type: 'string',
      fieldRequired: true
    },
    entityType: {
      title: 'Typ encji',
      type: 'string',
      fieldRequired: true
    },
    entityId: {
      title: 'Identyfikator encji',
      type: 'string',
      fieldRequired: true
    },
    optionId: {
      title: 'Identyfikator opcji',
      type: 'number',
      fieldRequired: true
    },
    edit: {
      type: 'boolean',
      computed: true
    }
  },
  allOf: [validationMessages]
};
